module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/rectification-dcb531fad92cc54e5590c92dfe2128af.svg";